const ITEMS = [
    "Graphene Drivers",
    "Quantum ANC",
    "Spatial Matrix",
    "60H Battery",
    "Ultra Lightweight",
    "4Hz – 48kHz",
];

function Row({ ariaHidden }) {
    return (
        <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
            {ITEMS.map((it, i) => (
                <span key={it} className="flex items-center">
                    <span
                        className={`whitespace-nowrap px-8 font-display text-2xl font-bold uppercase tracking-tight md:text-4xl ${
                            i % 2 ? "text-stroke" : "text-white/85"
                        }`}
                    >
                        {it}
                    </span>
                    <span
                        aria-hidden="true"
                        className="h-2 w-2 rotate-45 bg-volt/80"
                    />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <section
            aria-label="NEXORA feature highlights"
            className="relative overflow-hidden border-y border-white/5 bg-white/[0.015] py-7 md:py-9"
        >
            <div className="flex w-max animate-marquee">
                <Row ariaHidden={false} />
                <Row ariaHidden={true} />
            </div>
        </section>
    );
}
